import React from "react";
export default (({
  styles = {},
  ...props
}) => <svg className={styles["IconDelete26x26"] || "IconDelete26x26"} xmlns="http://www.w3.org/2000/svg" width="26" height="26" {...props}><g fill="none" fillRule="evenodd"><circle cx="13" cy="13" r="12.5" fill="#FFF" stroke="#888F9F" strokeOpacity=".4" /><path d="M17.04 8l.96.96L13.96 13 18 17.04l-.96.96L13 13.96 8.96 18 8 17.04 12.039 13 8 8.96 8.96 8 13 12.039 17.04 8z" fill="#9CA2AD" /></g></svg>);